import type { AxiosInstance } from "axios";

/**
 * When the user opens a child unit by code, navigation must land on the parent
 * listing — children are not standalone admin destinations.
 */
export function extractParentPropertyId(payload: unknown): number | null {
  if (!payload || typeof payload !== "object") return null;

  const root = payload as Record<string, unknown>;
  const data =
    root.data && typeof root.data === "object"
      ? (root.data as Record<string, unknown>)
      : root;
  const property =
    data.property && typeof data.property === "object"
      ? (data.property as Record<string, unknown>)
      : data;

  const candidates = [
    property.parent_property_id,
    property.parent_id,
    data.parent_property_id,
  ];

  for (const candidate of candidates) {
    const id = Number(candidate);
    if (Number.isFinite(id) && id > 0) return id;
  }

  return null;
}

export async function resolvePropertyNavigationId(
  client: AxiosInstance,
  requestedId: number
): Promise<number> {
  if (!Number.isFinite(requestedId) || requestedId <= 0) {
    return requestedId;
  }

  try {
    const response = await client.get(`/api/adm/properties/${requestedId}`);
    const parentId = extractParentPropertyId(response.data);
    return parentId ?? requestedId;
  } catch {
    return requestedId;
  }
}
